import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import clientReducer from "./slices/clientSlice";
import uiReducer from "./slices/uiSlice";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const reducers = combineReducers({
  current: userReducer,
  ui: uiReducer,
  ...clientReducer,
});

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = (state, action) => {
  // If the dispatched action is your logout action, set state to undefined
  if (action.type === "logout") {
    // Remove persisted data from storage
    storage.removeItem(`persist:${persistConfig.key}`);
    // This forces RTK to recreate the state using each slice's initialState
    state = undefined;
  }
  return reducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
